export const stream = {
  name: "stream" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 10" fill="currentColor"><path fill-rule="evenodd" d="M2 0a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm.989 2.6h.945v4.102h2.212V7.5H2.989V2.6Zm4.917 0v4.9H6.96V2.6h.945Zm3.01 3.752L9.585 2.6H8.59l1.807 4.9h1l1.841-4.9h-.973l-1.35 3.752Zm5.957-1.043h-2.002v1.393h2.388V7.5h-3.332V2.6h3.262v.798H14.87v1.113h2.002v.798Z" clip-rule="evenodd"/></svg>`,
  keywords: ["stream"],
  category: "media" as const,
};
